export default __webpack_public_path__ + "static/media/938f52f7bc17f163.2a309ef7ebd018961c1c5a36e6e8e952.svg";